import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import LayoutVue from '@page/layout.vue';
import Index from '@page/index.vue';
import Swiper from '@page/swiper.vue';
// 2 关于我们
import Introduction from '@page/association/Introduction.vue';
import Articles from '@page/association/articles.vue';
import Structure from '@page/association/structure.vue';
import JoinUs from '@page/association/joinUs.vue';
import Call from '@page/association/call.vue';
// 3 动态要闻
// 协会动态、协会工作 共用同一个页面
import Trends from '@page/associationNews/trends.vue';
import TrendsDetail from '@page/associationNews/trendsDetail.vue';
//4 驻京党建
import AssociationParty from '@page/partyBuild/associationParty.vue'
import PartyDetail from '@page/partyBuild/partyDetail.vue'

// 5 协会工作部
import InfoBranchIntroduction from '@page/associationBranch/infoBranchIntroduction.vue';
import Responsibilities from '@page/associationBranch/responsibilities.vue';
import InstitutionalSetup from '@page/associationBranch/institutionalSetup.vue';
import PersonnelDivision from '@page/associationBranch/personnelDivision.vue';
import Contact from '@page/associationBranch/contact.vue';
// 6 会员风采
// 6-1 驻京机构
import InstitutionList from '@page/city/institutionList.vue';
import InstitutionDetail from '@page/city/institutionDetail.vue';
import InstitutionWorkDetail from '@page/city/institutionWorkDetail.vue';

// 6-2 企业风采
import EnterpriseBranch from '@page/enterprise/enterpriseBranch.vue';
import EnterpriseBranchDetail from '@page/enterprise/enterpriseBranchDetail.vue';
// import InformationBranch from '@page/enterprise/informationBranch.vue';
// import InformationBranchDetail from '@page/enterprise/informationBranchDetail.vue';
// 6-3 精彩瞬间
import HighLight from '@page/city/highLight.vue';
import HightLightDetail from '@page/city/highLightDetail.vue';
//6-4 城市风采
import CityList from '@page/city/cityList.vue';
import CityDetail from '@page/city/cityDetail.vue';
import GoodProductList from '@page/city/goodProductList.vue';
import GoodProductDetail from '@page/city/goodProductDetail.vue';
import CulturalHeritageList from '@page/city/culturalHeritageList.vue';
import CulturalHeritageDetail from '@page/city/culturalHeritageDetail.vue';
import Company from '@page/city/company.vue';
import CompanyDetail from '@page/city/companyDetail.vue';

//7 信息交流
// 智库信息、批示专报信息、专报信息、一般信息 共用同一个页面
import InfoPool from '@page/infoPool/infoPool.vue';
import InfoPoolDetail from '@page/infoPool/infoPoolDetail.vue';
import ShareInfo from '@page/infoPool/shareInfo.vue';
import ShareInfoItemList from '@page/infoPool/shareInfoItemList.vue';
import ShareInfoItemDetail from '@page/infoPool/shareInfoItemDetail.vue';
//8 品牌活动
// 驻京沙龙、专家讲坛、项目路演、共用同一个页面
import SalonList from '@page/brandActivity/salonList.vue';
//驻京美食
import Food from '@page/food/food.vue';
import FoodDetail from '@page/food/foodDetail.vue';

//登录页
import Login from '@page/login.vue';
//会员中心
import UpdatePass from '@page/personalCenter/updatePass.vue';
import UpdateMemberInfo from '@page/personalCenter/updateMemberInfo.vue';
import UploadInfo from '@page/personalCenter/uploadInfo.vue';
import MyInfoPool from '@page/personalCenter/myInfoPool.vue';
import UploadCityStyle from '@page/personalCenter/uploadCityStyle.vue';
import MyCityStyle from '@page/personalCenter/myCityStyle.vue';
import UploadFood from '@page/personalCenter/uploadFood.vue';
import MyFood from '@page/personalCenter/myFood.vue';
import RecommendFood from '@page/personalCenter/recommendFood.vue';
import EventRegister from '@page/personalCenter/eventRegister.vue';
import UploadSpecialInfo from '@page/personalCenter/uploadSpecialInfo.vue';
import DownloadRecord from '@page/personalCenter/downloadRecord.vue';

/**-----首页其他----**/
import MedicalResource from '@page/other/medicalResource.vue';
import MedicalScience from '@page/other/medicalScience.vue';
import MedicalScienceDetail from '@page/other/medicalScienceDetail.vue';
import VipList from '@page/other/vipList.vue';
import VipDetail from '@page/other/vipDetail.vue';
import ThinkTanks from '@page/other/thinkTanks.vue';
import ExpertForumOther from '@page/other/expertForum.vue';
import ExpertForumOtherDeatil from '@page/other/expertForumDetail.vue';
import MedicalServiceGuideline from '@page/other/medicalServiceGuideline.vue';
import PolicyInterpretation from '@page/other/policyInterpretation.vue';
import PolicyDetail from '@page/other/policyDetail.vue';
import FullTextSearch from '@page/other/fullTextSearch.vue';

// 项目展示
import ProjectList from '@page/other/projectList.vue';
import ProjectDetail from '@page/other/projectDetail.vue';
let routes = [
    {
        path: '/',
        redirect: '/layout/index',
    },
    {
        path: '/layout',
        component: LayoutVue,
        children: [
            {
                path: 'index',
                name: 'Index',
                meta: {title: '首页', path: '/index', parentIndex: '1'},
                component: Index,
            },
            {
                path: 'policy-interpretation',
                name: 'PolicyInterpretation',
                meta: {title: '政策解读', path: '/policy-interpretation', parentIndex: '1'},
                component: PolicyInterpretation,
            },
            {
                path: 'policy-detail',
                name: 'PolicyDetail',
                meta: {title: '新闻详情', path: '/policy-detail', parentIndex: '1'},
                component: PolicyDetail,
            },
            {
                path: 'enterprise-branch',
                name: 'EnterpriseBranch',
                meta: {title: '企业工作部', path: '/enterprise-branch', parentIndex: '1'},
                component: EnterpriseBranch,
            },
            {
                path: 'enterprise-branch-detail',
                name: 'EnterpriseBranchDetail',
                meta: {title: '企业工作部活动详情', path: '/enterprise-branch-detail', parentIndex: '1'},
                component: EnterpriseBranchDetail,
            },
            // {
            //     path: 'information-branch',
            //     name: 'InformationBranch',
            //     meta: {title: '信息工作部', path: '/information-branch'},
            //     component: InformationBranch,
            // },
            // {
            //     path: 'information-branch-detail',
            //     name: 'InformationBranchDetail',
            //     meta: {title: '信息工作部详情', path: '/information-branch-detail'},
            //     component: InformationBranchDetail,
            // },
            {
                path: 'association-introduction',
                name: 'Introduction',
                meta: {title: '协会简介', path: '/association-introduction', parentIndex: '2'},
                component: Introduction,
            },
            {
                path: 'association-articles',
                name: 'Articles',
                meta: {title: '协会章程', path: '/association-articles', parentIndex: '2'},
                component: Articles,
            },
            {
                path: 'association-structure',
                name: 'Structure',
                meta: {title: '协会架构', path: '/association-structure', parentIndex: '2'},
                component: Structure,
            },
            {
                path: 'join-us',
                name: 'JoinUs',
                meta: {title: '申请入会', path: '/join-us', parentIndex: '2'},
                component: JoinUs,
            },
            {
                path: 'call',
                name: 'Call',
                meta: {title: '联系方式', path: '/call', parentIndex: '2'},
                component: Call,
            },
            {
                path: 'association-trends',
                name: 'Trends',
                meta: {title: '协会动态', path: '/association-trends', parentIndex: '3'},
                component: Trends,
            },
            {
                path: 'association-trends-detail',
                name: 'TrendsDetail',
                meta: {title: '动态详情', path: '/association-trends-detail', parentIndex: '3'},
                component: TrendsDetail,
            },
            {
                path: 'association-party',
                name: 'AssociationParty',
                meta: {title: '协会党建', path: '/association-party', parentIndex: '4'},
                component: AssociationParty,
            },
            {
                path: 'association-party-detail',
                name: 'PartyDetail',
                meta: {title: '协会党建详情', path: '/association-party-detail', parentIndex: '4'},
                component: PartyDetail,
            },
            {
                path: 'info-branch-introduction',
                name: 'InfoBranchIntroduction',
                meta: {title: '工作部简介', path: '/info-branch-introduction', parentIndex: '5-1'},
                component: InfoBranchIntroduction,
            },
            {
                path: 'info-branch-responsibilities',
                name: 'Responsibilities',
                meta: {title: '主要职责', path: '/info-branch-responsibilities', parentIndex: '5-2'},
                component: Responsibilities,
            },
            {
                path: 'info-institutiona-setup',
                name: 'InstitutionalSetup',
                meta: {title: '机构设置及职责', path: '/info-institutiona-setup', parentIndex: '5-3'},
                component: InstitutionalSetup,
            },
            {
                path: 'info-personnel-division/',
                name: 'PersonnelDivision',
                meta: {title: '人员分工', path: '/info-personnel-division', parentIndex: '5-4'},
                component: PersonnelDivision,
            },
            {
                path: 'info-branch-contact/',
                name: 'Contact',
                meta: {title: '联系方式', path: '/info-branch-contact', parentIndex: '5-5'},
                component: Contact,
            },
            {
                path: 'city-food',
                name: 'Food',
                meta: {title: '驻京美食', path: '/city-food', parentIndex: '10'},
                component: Food,
            },
            {
                path: 'city-food-detail',
                name: 'FoodDetail',
                meta: {title: '驻京美食详情', path: '/city-food-detail', parentIndex: '10'},
                component: FoodDetail,
            },
            {
                path: 'institution-list',
                name: 'InstitutionList',
                meta: {title: '驻京办风采', path: '/institution-list', parentIndex: '6'},
                component: InstitutionList,
            },
            {
                path: 'institution-detail',
                name: 'InstitutionDetail',
                meta: {title: '驻京机构详情', path: '/institution-detail', parentIndex: '6'},
                component: InstitutionDetail,
            },
            {
                path: 'institution-work-detail',
                name: 'InstitutionWorkDetail',
                meta: {title: '驻京机构详情', path: '/institution-work-detail', parentIndex: '6'},
                component: InstitutionWorkDetail,
            },
            {
                path: 'high-light',
                name: 'HighLight',
                meta: {title: '精彩瞬间', path: '/high-light', parentIndex: '1'},
                component: HighLight,
            },
            {
                path: 'high-light-detail',
                name: 'HightLightDetail',
                meta: {title: '精彩瞬间', path: '/high-light-detail', parentIndex: '1'},
                component: HightLightDetail,
            },
            {
                path: 'city-list',
                name: 'CityList',
                meta: {title: '城市风采', path: '/city-list', parentIndex: '6'},
                component: CityList,
            },
            {
                path: 'city-detail',
                name: 'CityDetail',
                meta: {title: '城市风采详情', path: '/city-detail', parentIndex: '6'},
                component: CityDetail,
            },
            {
                path: 'good-product-list',
                name: 'GoodProductList',
                meta: {title: '名特优产品', path: '/good-product-list', parentIndex: '6'},
                component: GoodProductList,
            },
            {
                path: 'good-product-detail',
                name: 'GoodProductDetail',
                meta: {title: '名特优产品详情', path: '/good-product-detail', parentIndex: '6'},
                component: GoodProductDetail,
            },
            {
                path: 'cultural-heritage-list',
                name: 'CulturalHeritageList',
                meta: {title: '非物质文化遗产', path: '/cultural-heritage-list', parentIndex: '6'},
                component: CulturalHeritageList,
            },
            {
                path: 'cultural-heritage-detail',
                name: 'CulturalHeritageDetail',
                meta: {title: '非物质文化遗产详情', path: '/cultural-heritage-detail',parentIndex: '6'},
                component: CulturalHeritageDetail,
            },
            {
                path: 'company-list',
                name: 'Company',
                meta: {title: '企业风采', path: '/company-list', parentIndex: '6'},
                component: Company,
            },
            {
                path: 'company-detail',
                name: 'CompanyDetail',
                meta: {title: '企业风采详情', path: '/company-detail', parentIndex: '6'},
                component: CompanyDetail,
            },
            {
                path: 'info-pool',
                name: 'InfoPool',
                meta: {title: '信息交流', path: '/info-pool', parentIndex: '8'},
                component: InfoPool,
            },
            {
                path: 'info-pool-detail',
                name: 'InfoPoolDetail',
                meta: {title: '信息交流详情', path: '/info-pool-detail', parentIndex: '8'},
                component: InfoPoolDetail,
            },
            {
                path: 'share-info',
                name: 'ShareInfo',
                meta: {title: '共享信息', path: '/share-info', parentIndex: '8'},
                component: ShareInfo,
            },
            {
                path: 'share-info-item',
                name: 'ShareInfoItemList',
                meta: {title: '共享信息', path: '/share-info-item', parentIndex: '8'},
                component: ShareInfoItemList,
            },
            {
                path: 'share-info-item-detail',
                name: 'ShareInfoItemDetail',
                meta: {title: '共享信息详情', path: '/share-info-item-detail', parentIndex: '8'},
                component: ShareInfoItemDetail,
            },
            {
                path: 'salon',
                name: 'SalonList',
                meta: {title: '驻京沙龙', path: '/salon', parentIndex: '7'},
                component: SalonList,
            },
            {
                path: 'login',
                name: 'Login',
                meta: {title: '登录', path: '/login'},
                component: Login,
            },
            {
                path: 'update-pass',
                name: 'UpdatePass',
                meta: {title: '修改密码', path: '/update-pass'},
                component: UpdatePass,
            },
            {
                path: 'update-member-info',
                name: 'UpdateMemberInfo',
                meta: {title: '会员信息', path: '/update-member-info'},
                component: UpdateMemberInfo,
            },
            {
                path: 'upload-special-info',
                name: 'UploadSpecialInfo',
                meta: {title: '上传专报信息', path: '/upload-special-info'},
                component: UploadSpecialInfo,
            },
            {
                path: 'project-list',
                name: 'ProjectList',
                meta: {title: '项目展示', path: '/project-list', parentIndex: '1'},
                component: ProjectList,
            },
            {
                path: 'project-detail',
                name: 'ProjectDetail',
                meta: {title: '项目详情', path: '/project-detail', parentIndex: '1'},
                component: ProjectDetail,
            },
            {
                path: 'medical-resource',
                name: 'MedicalResource',
                meta: {title: '北京医疗资源展示', path: '/medical-resource', parentIndex: '1'},
                component: MedicalResource,
            },
            {
                path: 'medical-science',
                name: 'MedicalScience',
                meta: {title: '医疗科普', path: '/medical-science', parentIndex: '1'},
                component: MedicalScience,
            },
            {
                path: 'medical-science-detail',
                name: 'MedicalScienceDetail',
                meta: {title: '医疗科普', path: '/medical-science-detail', parentIndex: '1'},
                component: MedicalScienceDetail,
            },
            {
                path: 'medical-service-guideline',
                name: 'MedicalServiceGuideline',
                meta: {title: '医疗服务指引', path: '/medical-service-guideline', parentIndex: '1'},
                component: MedicalServiceGuideline,
            },
            
            {
                path: 'vip-list',
                name: 'VipList',
                meta: {title: '会员展示', path: '/vip-list', parentIndex: '1'},
                component: VipList,
            },
            {
                path: 'vip-detail',
                name: 'VipDetail',
                meta: {title: '会员详情', path: '/vip-detail', parentIndex: '1'},
                component: VipDetail,
            },
            {
                path: 'think-tanks',
                name: 'ThinkTanks',
                meta: {title: '合作智库', path: '/think-tanks', parentIndex: '1'},
                component: ThinkTanks,
            },
            {
                path: 'export-forum',
                name: 'ExpertForumOther',
                meta: {title: '专家讲坛', path: '/export-forum', parentIndex: '1'},
                component: ExpertForumOther,
            },
            {
                path: 'export-forum-detail',
                name: 'ExpertForumOtherDeatil',
                meta: {title: '专家讲坛详情', path: '/export-forum-detail', parentIndex: '1'},
                component: ExpertForumOtherDeatil,
            },
            {
                path: 'upload-info',
                name: 'UploadInfo',
                meta: {title: '上传信息', path: '/upload-info'},
                component: UploadInfo,
            },
            {
                path: 'my-info-pool',
                name: 'MyInfoPool',
                meta: {title: '我的信息交流', path: '/my-info-pool', parentIndex: ''},
                component: MyInfoPool,
            },
            {
                path: 'upload-city-style',
                name: 'UploadCityStyle',
                meta: {title: '上传会员风采', path: '/upload-city-style'},
                component: UploadCityStyle,
            },
            // {
            //     path: 'upload-city-style-add',
            //     name: 'UploadCityStyleAdd',
            //     meta: {title: '上传会员风采', path: '/upload-city-style-add'},
            //     component: UploadCityStyleAdd,
            // },
            {
                path: 'my-city-style',
                name: 'myCityStyle',
                meta: {title: '我的会员风采', path: '/my-city-style'},
                component: MyCityStyle,
            },
            {
                path: 'upload-food',
                name: 'UploadFood',
                meta: {title: '上传驻京美食', path: '/upload-food'},
                component: UploadFood,
            },
            {
                path: 'recommend-food',
                name: 'RecommendFood',
                meta: {title: '上传驻京美食', path: '/recommend-food'},
                component: RecommendFood,
            },
            {
                path: 'my-food',
                name: 'MyFood',
                meta: {title: '我的驻京美食', path: '/my-food'},
                component: MyFood,
            },
            {
                path: 'event-rigister',
                name: 'EventRegister',
                meta: {title: '活动报名', path: '/event-rigister'},
                component: EventRegister,
                
            },
            {
                path: 'swiper',
                name: 'Swiper',
                meta: {title: '上传动态要闻', path: '/swiper'},
                component: Swiper,
            },
            {
                path: 'full-text-search',
                name: 'FullTextSearch',
                meta: {title: '全站搜索', path: '/full-text-search'},
                component: FullTextSearch,
            },
            {
                path: 'download-record',
                name: 'DownloadRecord',
                meta: {title: '下载记录', path: '/download-record'},
                component: DownloadRecord,
            },
        ],
        
    }
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});
export default router;